// Núcleo puro da ferramenta Cálculo R/G — paridade com o Silverlight
// (GraficoDePrata/Objects/Line/CalculoRG.cs). P0 = entrada (nível 0),
// P1 = stop (nível -1); risco = entrada - stop.
//
//   preço(nível) = (entrada - stop) · (nível + 1) + stop
//     nível -1 → stop · nível 0 → entrada · nível 3 → alvo 3:1 · ...
//
// Rótulo legado: string.Format("{0:f2} ({1:f2} {2:f2} %)", preço, delta, perc)
// com delta = preço - entrada e perc = Math.Round(delta/entrada·100, 2) — o
// ToString do C# derruba zeros à direita do perc ("1.5", não "1.50"); o
// separador decimal aqui é ponto (padrão dos rótulos do odin), não a cultura
// pt-BR do app legado.

export const RG_DEFAULT_LEVELS = [
  { level: -1, display: true, color: "#C00000" },
  { level: 0, display: true, color: null },
  { level: 3, display: true, color: null },
  { level: 4, display: true, color: null },
  { level: 5, display: true, color: null },
];

export const rgLevelPrice = ({ entrada, stop, level }) =>
  (entrada - stop) * (level + 1) + stop;

export const rgLabel = ({ price, entrada }) => {
  const delta = price - entrada;
  // Legado divide por entrada sem guarda (entrada 0 → Infinity); preço 0 não
  // existe em dado real — aqui degrada para 0 em vez de imprimir "∞".
  const rawPerc = entrada !== 0 ? (delta / entrada) * 100 : 0;
  const perc = Number.isFinite(rawPerc)
    ? String(parseFloat(rawPerc.toFixed(2)))
    : "0";
  return `${price.toFixed(2)} (${delta.toFixed(2)} ${perc} %)`;
};
